export const WaiveOffModalStyles = {
  content: {
    margin: "auto",
    width: "25%",
    height: "fit-content",
    borderRadius: "10px",
    padding: "10px 20px 10px 20px",
    zIndex: 1300,
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
  },
  overlay: {
    zIndex: 1300,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(1px)",
  },
};
export const LogOutModalStyles = {
  content: {
    borderRadius: "15px",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    marginLeft: "76.5%",
    width: "20%",
    height: "fit-content",
    marginTop: "10px",
    padding: "10px",
  },
  overlay: {
    background: "none",
    backdropFilter: "blur(0px)",
    zIndex: 1000,
  },
};

export const EditModalStyles = {
  content: {
    margin: "auto",
    width: "35%",
    height: "fit-content",
    borderRadius: "10px",
    padding: "10px 20px 10px 20px",
    zIndex: 1300,
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
  },
  overlay: {
    zIndex: 1100,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(1px)",
  },
};

export const EditReplaceModalStyles = {
  content: {
    margin: "auto",
    width: "35%",
    height: "fit-content",
    borderRadius: "10px",
    padding: "10px 20px 10px 20px",
    zIndex: 1300,
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
  },
  overlay: {
    zIndex: 1300,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(1px)",
  },
};
export const VideoPreviewModalStyles = {
  content: {
    margin: "auto",
    borderRadius: "10px",
    height:"80%",
    padding: "10px 20px 10px 20px",
    zIndex: 1300,
    background: "#20d450",
    boxShadow:
      "transparent",
  },
  overlay: {
    zIndex: 2000,
    // background: "#20d450",
    backdropFilter: "blur(1px)",
  },
};
export const EditMessageModalStyles = {
  content: {
    margin: "auto",
    width: "35%",
    height: "50%",
    borderRadius: "10px",
    padding: "10px 20px 10px 20px",
    zIndex: 1300,
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
  },
  overlay: {
    zIndex: 2000,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(1px)",
  },
};

export const ImageModalStylesInTickets = {
  content: {
    margin: "auto",
    height: "90%",
    width: "90%",
    borderRadius: "10px",
    padding: "10px 20px 10px 20px",
    background: "rgba(0, 0, 0) !important",
    zIndex: 1700,
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
  },
  overlay: {
    zIndex: 1203,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(1px)",
  },
};

export const ReplaceModalStylesInItemDeatils = {
  content: {
    margin: "auto",
    height: "40%",
    width: "30%",
    borderRadius: "10px",
    padding: "10px 20px 10px 20px",
    background: "rgba(0, 0, 0) !important",
    zIndex: 1700,
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
  },
  overlay: {
    zIndex: 1203,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(1px)",
  },
};
export const ViewConfigurationStyles = {
  content: {
    margin: "auto",
    width: "35%",
    height: "80%",
    borderRadius: "10px",
    padding: "10px 20px 10px 20px",
    zIndex: 1300,
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
  },
  overlay: {
    zIndex: 1200,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(1px)",
  },
};

export const ViewAssetStyles = {
  content: {
    margin: "auto",
    width: "45%",
    height: "70%",
    borderRadius: "10px",
    padding: "10px 20px 10px 20px",
    zIndex: 1300,
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
  },
  overlay: {
    zIndex: 1201,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(1px)",
  },
};
export const ViewAssetStylesRaiseTicket = {
  content: {
    margin: "auto",
    width: "45%",
    height: "70%",
    borderRadius: "10px",
    padding: "10px 20px 10px 20px",
    zIndex: 1100,
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
  },
  overlay: {
    zIndex: 1100,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(1px)",
  },
};
export const ViewMoreFileStyles = {
  content: {
    margin: "auto",
    width: "25%",
    height: "70%",
    borderRadius: "10px",
    padding: "10px 20px 10px 20px",
    zIndex: 1100,
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
  },
  overlay: {
    zIndex: 1100,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};
export const CustomModalStyles = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginTop: " 100px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "70%",
    width: "80%",
  },
  overlay: {
    zIndex: 1100,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};
export const AddModalStyles = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginTop: "40px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "80%",
    width: "90%",
  },
  overlay: {
    zIndex: 1200,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};
export const AddCaseStudyStyles = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginTop: "40px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "80%",
    width: "60%",
  },
  overlay: {
    zIndex: 1200,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};

export const ViewModalStyles = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "90%",
    width: "90%",
  },
  overlay: {
    zIndex: 1001,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};

export const ViewRaisedTicketModalStyles = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "90%",
    width: "90%",
  },
  overlay: {
    zIndex: 1200,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};

export const ViewTicketModalStyles = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "90%",
    width: "60%",
  },
  overlay: {
    zIndex: 1600,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};

export const ViewItemsModalStyles = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "90%",
    width: "60%",
  },
  overlay: {
    zIndex: 1201,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};

export const ViewModalStylesAsset = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "90%",
    width: "90%",
  },
  overlay: {
    zIndex: 2000,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};

export const ViewItemModalStyles = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "90%",
    width: "90%",
  },
  overlay: {
    zIndex: 1001,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};

export const LoadingModalStyles = {
  content: {
    margin: "auto",
    width: "30%",
    height: "fit-content",
    boxshadow: "none",
    border: "none",
    padding: "10px 20px 10px 20px",
  },
  overlay: {
    zIndex: 5000,
    backdropFilter: "blur(1px)",
  },
};


export const PrintModalStyles = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "90%",
    width: "fit-content",
  },
  overlay: {
    zIndex: 1001,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};

export const HistoryModalStyles = {
  content: {
    borderRadius: "10px",
    boxShadow:
      "0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 15px 40px rgba(0, 0, 0, 0.4)",
    filter: "drop-shadow(8px -3px 4px rgba(0, 0, 0, 0.25))",
    padding: "10px 20px 10px 20px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "90%",
    width: "60%",
  },
  overlay: {
    zIndex: 1000,
    background: "rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(0px)",
  },
};
